import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const customRoutes = [
  { method: "PUT", path: "/:id/review", handlerName: "reviewRequest" },
  { method: "POST", path: "/apply-changes", handlerName: "applyChanges" },
];

const baseService = createCrudService("scheduleChangeRequests", customRoutes, router);

export const scheduleChangeRequestsService = {
  ...baseService,
  list: (params) => api.getCall("/api/scheduleChangeRequests", params), // Override to accept params

  // Review a schedule change request (approve or deny)
  reviewRequest: async (id, status, adminNotes = null) => {
    return api.putCall(`/api/scheduleChangeRequests/${id}/review`, {
      status,
      admin_notes: adminNotes
    });
  },

  // Apply approved schedule changes (admin only - typically called by cron job)
  applyChanges: async () => {
    return api.postCall(`/api/scheduleChangeRequests/apply-changes`);
  },

  // Get requests filtered by status
  getByStatus: async (status) => {
    return api.getCall(`/api/scheduleChangeRequests`, { status });
  },

  // Get pending requests for admin approval
  getPendingRequests: async () => {
    return api.getCall(`/api/scheduleChangeRequests`, { status: 'pending' });
  },

  // Get requests for a specific user
  getByUser: async (userId) => {
    return api.getCall(`/api/scheduleChangeRequests`, { user_id: userId });
  },

  // Get requests that haven't been applied yet
  getUnappliedRequests: async () => {
    return api.getCall(`/api/scheduleChangeRequests`, { applied: false, status: 'approved' });
  }
};
